import { DefaultTheme } from '../../components/theme';
import { ColorPalette2022Branding } from '../../components/theme.palette';

export const CSS = {
	container: 'c-TopologicalEditorCollectionListContainer',
	item: 'c-TopologicalEditorCollectionListItem',
	variant: 'c-TopologicalEditorCollectionListItem--variant',
	selected: 'c-TopologicalEditorCollectionListItem--selected',
	unsaved: 'c-TopologicalEditorCollectionListItem--unsaved',
	info: 'c-TopologicalEditorCollectionListItem--info',
	noLocation: 'c-TopologicalEditorCollectionListItem--no-location',
	redDot: 'c-TopologicalEditorCollectionListItem__RedDot',
};

export const Style = {
	[CSS.container]: {
		padding: DefaultTheme.space(1),
		flexGrow: '1',
		overflow: 'auto',
	},

	[CSS.item]: {
		display: 'flex',
		'align-items': 'center',
		'padding-left': DefaultTheme.space(3),
		cursor: 'pointer',
		'border-left': `${DefaultTheme.space(1)} solid transparent`,
		'&:hover': {
			backgroundColor: DefaultTheme.font.color.divider,
		},
	},

	// A variant is nested under its parent pole, matching the map page's job-list variant row
	// (.c-VariantCard__row): the same indent marks it as a child, and it keeps the normal text colour and
	// selection highlight of a collection rather than being greyed/italic (so the selected state matches too).
	[CSS.variant]: {
		'padding-left': DefaultTheme.space(8),
	},

	[CSS.selected]: {
		'background-color': DefaultTheme.background.offWhite,
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'border-color': DefaultTheme.color.accent,
	},

	[CSS.unsaved]: {
		'font-style': 'italic',
		flex: 1,
	},

	[CSS.info]: {
		'font-style': 'italic',
		'text-align': 'right',
		flex: 1,
		'padding-right': DefaultTheme.space(1),
		'font-size': '90%',
		color: DefaultTheme.font.color.disabled,
	},

	[CSS.noLocation]: {
		color: DefaultTheme.font.color.disabled,
		cursor: 'default',
	},
	[CSS.redDot]: {
		display: 'inline-block',
		width: '8px',
		height: '8px',
		'border-radius': '50%',
		'background-color': ColorPalette2022Branding.lightRed,
		border: '1px solid #FFFFFF',
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'margin-left': DefaultTheme.space(1),
		'flex-shrink': '0',
	},
};
